import React, { useState } from "react";
import "../assets/css/main.css"; 
import { useTranslation } from "react-i18next";


function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);
  const { t } = useTranslation();

  const faqData = [
    {
      question: t("FAQQuestion1"),
      answer: t("FAQAnswer1"),
    },
    {
      question: t("FAQQuestion2"),
      answer: t("FAQAnswer2"),
    },
    {
      question: t("FAQQuestion3"),
      answer: t("FAQAnswer3"),
    },
    {
      question: t("FAQQuestion4"),
      answer: t("FAQAnswer4"),
    },
    {
      question: t("FAQQuestion5"),
      answer: t("FAQAnswer5"),
    },

  ];



  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (

    <>
    <div className="faq-section">
      <div className="container section-title">
        <h1 className="services-title">{t("FAQAccroche")}</h1>
      </div>
    </div>

    <section id="faq" className="faq section">
      <div className="container">
        <div className="row gy-4">
          {/* Colonne gauche avec titre et description */}
          <div className="col-lg-4" data-aos="fade-up" data-aos-delay="100">
            <div className="content px-xl-5">
              <h3>
                <span>Frequently Asked </span>
                <strong>Questions</strong>
              </h3>
              <p>
                {t("FAQDscription")}
              </p>
            </div>
          </div>

          {/* Colonne droite avec les questions */}
          <div className="col-lg-8" data-aos="fade-up" data-aos-delay="200">
            <div className="faq-container">
              {faqData.map((item, index) => (
                <div
                  key={index}
                  className={`faq-item ${openIndex === index ? "faq-active" : ""}`}
                  onClick={() => toggleFAQ(index)}
                >
                  <h3>
                    <span className="num">{index + 1}.</span> <span>{item.question}</span>
                  </h3>
                  <div className="faq-content">
                    <p>{item.answer}</p>
                  </div>
                  <i className={`faq-toggle bi ${openIndex === index ? "bi-chevron-down" : "bi-chevron-right"}`}></i>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
}

export default FAQ;
